var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C9.33337 0 9.63944 0.183298 9.79542 0.476203L17.8955 15.6867C18.0432 15.964 18.0337 16.2978 17.8709 16.5666C17.7081 16.8354 17.4158 17 17.1001 17H0.899879C0.584228 17 0.291882 16.8354 0.129067 16.5666C-0.0337224 16.2978 -0.0431843 15.964 0.104457 15.6867L8.20458 0.476203C8.36056 0.183298 8.66663 0 9 0ZM2.39492 15.2105H15.6051L9 2.80654L2.39492 15.2105Z",
    fill: "#EEC315"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09999 10.7368V7.15789C8.09999 6.66374 8.50294 6.26316 9 6.26316C9.49706 6.26316 9.90001 6.66374 9.90001 7.15789V10.7368C9.90001 11.231 9.49706 11.6316 9 11.6316C8.50294 11.6316 8.09999 11.231 8.09999 10.7368Z",
    fill: "#EEC315"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09999 13.4298V13.4211C8.09999 12.9269 8.50294 12.5263 9 12.5263C9.49706 12.5263 9.90001 12.9269 9.90001 13.4211V13.4298C9.90001 13.9239 9.49706 14.3245 9 14.3245C8.50294 14.3245 8.09999 13.9239 8.09999 13.4298Z",
    fill: "#EEC315"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9869abc2483abf359adb4e2fed6d6335.svg";
export { ForwardRef as ReactComponent };